<template>
  <div class="about">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1>Other Community Resource Lists</h1>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <p>There are other organizations in our community that also compile resource lists to share. We have included them below for reference. Each list's sponsor is responsible for maintaining its accuracy and updates. NCHIIN is only responsible for maintaining the North Coast Resource Hub and cannot be held accountable for the contents of other lists.</p>
        </div>
      </div>
      <div class="row other-resources">
        <div class="col-3">
          <div>
            <p><a href="https://humboldtgov.org/DocumentCenter/View/54880/Humboldt-Community-Resource-List-PDF?bidId=">Humboldt County Resource List</a></p>
            <p>Produced by the Department of Health and Human Services this is a comprehensive guide with local resources, updated twice a year.</p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="https://211humboldt.org/">211humboldt.org</a></p>
            <p>Humboldt County information and referral services for resources for all ages. Searchable database on web site.</p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="https://humboldtgov.org/DocumentCenter/View/121948/Humboldt-County-Resource-List---Urgent-Needs-PDF?bidId=">Humboldt Community Resource List - Urgent Needs</a></p>
            <p>The Urgent Needs list is a quick one-page document that can be handed to clients, patients and other community members.</p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="https://humboldtgov.org/DocumentCenter/View/844/Substance-Use-Disorder-Programs-Contact-List-PDF?bidId=">Partner Info Sheets | Humboldt County, CA - Official Website</a></p>
            <p>DHHS Program Info Sheets (references for Case Managers and Community Health Workers)</p>
          </div>
        </div>
        <div class="col-3">
          <div><p><a href="https://partnershiphp.org/Community/Pages/Humboldt-County-Resources.aspx">Partnership Health Plan: Humboldt County Resources</a></p></div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="https://www.queerhumboldt.org/resources">Queer Humboldt - Resources</a></p>

          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="https://humboldtgov.org/DocumentCenter/View/134722/Affordable-Housing-List-12-2024-PDF">Humboldt County Affordable Housing List</a></p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="https://athomeinhumboldt.com/events-for-kids/">Fun activities and educational/support programs geared towards children and families</a></p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="https://ncsheadstart.org/wp-content/uploads/2023/06/Humboldt-Family-Resource-Guide-22-23-ENGLISH.pdf">NorthCoast Children’s Services Family Resource Guide</a></p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="https://www.ellenadornews.com/2024/12/05/resources-in-humboldt-county-for-undocumented-community-members/">Resources in Humboldt County for undocumented community members</a></p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="https://docs.google.com/spreadsheets/d/1wlG4DE06EghjigXdwMIvTUbM3kq8xp-Qduuww_QNTkk/edit?gid=621995213#gid=621995213">Enhanced Case Management and Community Supports Contracted Providers List</a></p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a target="_blank" href="/assets/external-resources/SLE_List_English_12_2025.pdf">Sober Living Environment (SLE) and Recovery Housing Resources in Humboldt</a></p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="/assets/external-resources/SLE_List_Spanish_12_2025.pdf">Entornos de Vivienda Sobria (SLE) y Recursos de Vivienda de Recuperación en el Condado de Humboldt</a></p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="/assets/external-resources/SUD_Treatment_list_English_9_2025.pdf">Substance Use Disorder Treatment Programs and Support Services in Humboldt County</a></p>
          </div>
        </div>
        <div class="col-3">
          <div>
            <p><a href="/assets/external-resources/SUD_Treatment_List_Spanish_11_2025.pdf">Programas de tratamiento para trastornos por uso de sustancias y servicios de apoyo en el Condado de Humboldt</a></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: 'About',
  };
</script>

<style>
  .other-resources > div > div {
    margin: 15px 0;
    padding: 10px;
    background-color: #fff;
    border: 1px solid #e8e8e8;
  }
</style>